export const HASSEntities = (entities = {}, action) => {
  if (action.type === "HASS_ENTITIES") {
    return action.payload;
  }

  return entities;
};
